// extracted by mini-css-extract-plugin
export var schemaTableCell = "schema-table-module--schemaTableCell--4011d";